export default "__VITE_ASSET__BS5AO6sR__"